import React from "react";
import { GridPagination } from "@mui/x-data-grid";

const CustomPagination = (props: any) => {
  return <GridPagination {...props} labelRowsPerPage={"Linhas por página"} />;
};

export default CustomPagination;
